import React, { useContext, useState } from "react";
import "../App.css";
import { useHistory } from "react-router-dom";
import { Form, FormGroup, Button, Input } from "reactstrap";
import MyLoader from "./util/loader";
import MyError from "./util/error";
import Api from "./api/api";
import { AuthContext } from "../context/AuthContext";

const Login = () => {
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showError, setShowError] = useState(false);
  const [error, setError] = useState("");
  const [loader, setLoader] = useState(false);
  const { isLoggedIn, setUser } = useContext(AuthContext);

  if (isLoggedIn) {
    console.log("already logged in");
    history.push("/");
    return null;
  }

  const forgotPassword = () => {
    history.push("/forgot-password");
  };

  const loginAdmin = () => {
    if (email === "" || password === "") {
      return;
    }
    setLoader(true);
    Api.loginAdmin(
      email,
      password,
      (response) => {
        setLoader(false);
        if (response.status === "success") {
          // MyStorage.setUser(response.data);
          setUser(response.data);
          history.push("/");
        } else {
          setShowError(true);
          setError("Could not login!");
        }
      },
      (error) => {
        setLoader(false);
        console.log("error: " + JSON.stringify(error));
        setShowError(true);
        setError("Could not login!");
      }
    );
  };

  const onSubmit = (e) => {
    e.preventDefault();
    loginAdmin();
  };

  return (
    <div className="app">
      <div className="text-center text-white">
        <h4>PCM Admin Login</h4>
      </div>
      <Form className="form" onSubmit={onSubmit}>
        <FormGroup>
          <Input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </FormGroup>
        <FormGroup style={{ marginTop: 10 }}>
          <Input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </FormGroup>
        <button
          type="button"
          style={{
            marginTop: 20,
            fontSize: 16,
            borderWidth: 0,
            backgroundColor: "transparent",
            color: "blue",
          }}
          className="btn-block btn-dark"
          onClick={forgotPassword}
        >
          Forgot Password?
        </button>

        <MyError showError={showError} error={error} />

        <Button
          type="submit"
          style={{ marginTop: 20, fontSize: 16 }}
          className="btn-block btn-dark"
        >
          Login
        </Button>
      </Form>
      <MyLoader loader={loader} marginTop={-10} />
    </div>
  );
};

export default Login;
